<div class="info-box">
  <div class="info-box-icon">
      <svg-icon
        [src]="'assets/icons/' + icon"
      ></svg-icon>
    
  </div>
  <div class="info-box-content-container">
    <div class="info-box-title">
      <ng-content select="[title]"></ng-content>
    </div>
    <div class="info-box-description">
      <ng-content select="[content]"></ng-content>
    </div>
  </div>
</div>